import { fmt } from '../../utils';

/**
 * Оформление подписи оси диаграммы.
 *
 * Цвет задан переменной темы, а не классом-утилитой: подписи осей recharts рисует атрибутом
 * `fill` на своём `<text>`, и класс потребителя до него не доходит.
 */
export const CHART_AXIS_TICK = { fill: 'var(--color-muted-foreground)', fontSize: 12 };

/** Цвет линий осей и сетки — тот же токен границы, что и у остальных блоков дашборда. */
export const CHART_LINE_COLOR = 'var(--color-border)';

/** Цвет линии и столбцов диаграммы. */
export const CHART_SERIES_COLOR = 'var(--color-primary)';

/**
 * Подпись величины на оси.
 *
 * Обёртка вокруг {@link fmt} нужна из-за подписи вызова: recharts передаёт форматтеру вторым
 * доводом номер деления, и он занял бы место точности.
 */
export const formatAxisValue = (value: number): string => fmt(value);
